function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.5 9H46.5V39H1.5V9Z",
  fill: "#FFF4E3"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.14,
  d: "M1.5 9L24 29.55L46.5 9L21.75 35.25L3.75 13.5V39H1.5V9Z",
  fill: "#000064"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M1.5 39L16.5 23.7M1.5 9L24 30.75L46.5 9H1.5ZM31.5 23.7L46.5 39L31.5 23.7Z",
  stroke: "#48568B",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M1.5 9H46.5V39H1.5V9Z",
  stroke: "#48568B",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgEmail = function SvgEmail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/email.44cfe849.svg";
export { ForwardRef as ReactComponent };